import React from "react"

import { graphql, useStaticQuery } from "gatsby"
import Image from "gatsby-plugin-sanity-image"
import PropTypes from "prop-types"

import * as styles from "./newsletter-game.module.scss"
import Button from "../../atoms/button"
import CopyContainer from "../../atoms/copy-container"
import Grid from "../../atoms/grid"
import Heading from "../../atoms/heading"
import NewsletterPartner from "../newsletter-partner"

const NewsletterGame = ({ section }) => {
  const { sanitySettings, allSanityDictionary } = useStaticQuery(graphql`
    {
      sanitySettings {
        default_images {
          game {
            ...ImageWithPreview
          }
        }
      }
      allSanityDictionary {
        nodes {
          key {
            current
          }
          value
        }
      }
    }
  `)
  return (
    <div className={styles.wrapper}>
      <Grid col={2} nowrap tight>
        <div className={styles.content}>
          <div className={styles.heading}>
            <Heading level={4}>{section.title}</Heading>
            <NewsletterPartner
              section={section}
              dictionary={allSanityDictionary.nodes}
            />
          </div>
          <CopyContainer content={section._rawDescription} />
          <div>
            <Button url={`/${section.game._type}/${section.game.slug.current}`}>
              {
                allSanityDictionary.nodes.find(
                  (item) => item.key.current === "play"
                )?.value
              }
            </Button>
          </div>
        </div>
        <div>
          {section.image ? (
            <Image {...section.image} width={300} />
          ) : (
            <Image {...sanitySettings.default_images.game} width={300} />
          )}
        </div>
      </Grid>
    </div>
  )
}

export default NewsletterGame

NewsletterGame.propTypes = {
  section: PropTypes.object.isRequired,
}
